import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { filterMainBannerItems } from '@/app/donation/(home)/_utils/filterMainBannerItems';
import { DONATION_ROUTES } from '@/constants';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
export const useCategory = () => {
  const $ = _c(22);
  const {
    entry
  } = useWebviewTypeEntry();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home/gift-category/primary"](),
      select: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: giftList,
    isPending: isGiftListPending
  } = useQuery(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home-love/main/institution-specialty"](),
      select: _temp5
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: institutionList,
    isPending: isInstitutionListPending
  } = useQuery(t1);
  let t2;
  if ($[2] !== entry) {
    t2 = UnauthQueryOptions["get:/wello/v2/allows/home/institution-event/ordered"]({
      query: {
        excludeEndedYN: true,
        entry
      }
    });
    $[2] = entry;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== entry) {
    t3 = data_1 => {
      const trimmed = filterMainBannerItems(data_1.context?.contents ?? [], entry);
      return trimmed.map(_temp6);
    };
    $[4] = entry;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      ...t2,
      select: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data: eventList,
    isPending: isEventListPending
  } = useQuery(t4);
  let t5;
  if ($[9] !== giftList) {
    t5 = {
      id: "gift",
      label: "\uB2F5\uB840\uD488",
      children: giftList
    };
    $[9] = giftList;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== institutionList) {
    t6 = {
      id: "institution",
      label: "\uC9C0\uC5ED",
      children: institutionList
    };
    $[11] = institutionList;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== eventList) {
    t7 = eventList && eventList.length > 0 ? {
      id: "event",
      label: "\uC774\uBCA4\uD2B8",
      children: eventList
    } : null;
    $[13] = eventList;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = [{
      id: "category",
      label: "\uCE74\uD14C\uACE0\uB9AC",
      children: [t5, t6, t7].filter(_temp7)
    }];
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const categoryData = t8;
  const t9 = isGiftListPending || isInstitutionListPending || isEventListPending;
  let t10;
  if ($[19] !== categoryData || $[20] !== t9) {
    t10 = {
      categoryData,
      isPending: t9
    };
    $[19] = categoryData;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
function _temp(item) {
  return {
    id: `gift-${item.giftCategoryId}`,
    label: item.categoryName,
    href: DONATION_ROUTES.GIFTS.withSearchParams({
      searchParams: {
        categoryId: item.giftCategoryId
      }
    })
  };
}
function _temp2(data) {
  return data.context?.contents?.map(_temp);
}
function _temp3(a, b) {
  return a.institutionShortName.localeCompare(b.institutionShortName);
}
function _temp4(item_0) {
  return {
    id: `institution-${item_0.institutionId}`,
    label: item_0.institutionShortName,
    href: DONATION_ROUTES.HOMETOWNS_DETAIL.pathname({
      id: item_0.slugId ?? item_0.institutionId
    })
  };
}
function _temp5(data_0) {
  const sortedList = (data_0.context?.contents ?? []).slice().sort(_temp3).map(_temp4);
  return [{
    id: "institution-all",
    label: "\uC804\uCCB4",
    href: DONATION_ROUTES.GIFTS.pathname
  }, ...sortedList];
}
function _temp6(item_1) {
  return {
    id: `event-${item_1?.eventId || item_1.title}`,
    label: item_1.title,
    href: item_1.href
  };
}
function _temp7(item_2) {
  return item_2 !== null;
}